import { z } from 'zod/v4';
export const PlexFilterValueNodeSchema = z.object({
    type: z.literal('value'),
    field: z.string(),
    // We should start populating this to know how to parse out the value, if necessary
    fieldType: z.string().optional(),
    op: z.string(),
    value: z.string(),
});
export const PlexFilterOperatorNodeSchema = z.object({
    type: z.literal('op'),
    op: z.union([z.literal('or'), z.literal('and')]),
    get children() {
        return z.array(PlexFilterSchema);
    },
});
export const PlexFilterSchema = z.discriminatedUnion('type', [
    PlexFilterOperatorNodeSchema,
    PlexFilterValueNodeSchema,
]);
export const PlexSortSchema = z.object({
    field: z.string(),
    direction: z.union([z.literal('asc'), z.literal('desc')]),
});
export const PlexSearchSchema = z.object({
    filter: PlexFilterSchema.optional(),
    sort: PlexSortSchema.optional(),
    limit: z.number().nonnegative().optional().catch(undefined),
});
z.globalRegistry.add(PlexFilterSchema, { id: 'PlexFilter' });
//# sourceMappingURL=plexSearch.js.map